export default "__VITE_ASSET__DDu9NwHi__"